<template>
  <div class="main-content">
    <!-- 检索过滤区域 -->
    <div class="search-wrapper marginBottom20">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <!-- 课程名称 -->
        <el-form-item label="课程标题 :">
          <el-input
            v-model="searchData.title"
            placeholder="请输入课程标题"
            clearable
            maxlength="100"
            style="width: 240px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>

        <!-- 分类级联选择 -->
        <el-form-item label="课程分类 :">
          <el-cascader
            v-model="searchClassifyIds"
            :options="classifyCascaderOptions"
            placeholder="全部分类"
            clearable
            change-on-select
            style="width: 260px"
          ></el-cascader>
        </el-form-item>

        <!-- 精品状态 -->
        <!-- <el-form-item label="是否精品 :">
          <el-select
            v-model="searchData.isFeatured"
            placeholder="全部"
            clearable
            style="width: 150px"
          >
            <el-option label="精品" :value="1"></el-option>
            <el-option label="普通" :value="2"></el-option>
          </el-select>
        </el-form-item> -->

        <!-- 上架状态 -->
        <el-form-item label="上架状态 :">
          <el-select
            v-model="searchData.state"
            placeholder="全部"
            clearable
            style="width: 150px"
          >
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <!-- 按钮区 -->
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearch"
            >查询</el-button
          >
          <el-button size="medium" icon="el-icon-refresh" @click="handleReset"
            >重置</el-button
          >
          <el-button
            size="medium"
            type="danger"
            plain
            icon="el-icon-download"
            :disabled="multipleSelection.length === 0"
            @click="handleBatchOffline"
            style="margin-right: 10px"
          >
            批量下架
          </el-button>

          <el-button
            size="medium"
            type="primary"
            icon="el-icon-plus"
            @click="handleCreate"
          >
            新增课程
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据列表表格 -->
    <div class="table-container">
      <el-table
        v-loading="showLoading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- 复选框列 -->
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>

        <!-- 课程封面 -->
        <el-table-column label="课程封面" width="120" align="center">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.image"
              style="width: 80px; height: 45px"
              :src="row.image"
              :preview-src-list="[row.image]"
              fit="cover"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>

        <!-- 课程标题 -->
        <el-table-column
          prop="title"
          label="课程标题"
          min-width="180"
          header-align="center"
          align="center"
        >
          <template slot-scope="{ row }">
            <span class="course-title">{{ row.title }}</span>
          </template>
        </el-table-column>

        <!-- 课程分类 -->
        <el-table-column label="分类" min-width="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.classifyName || "-" }}</span>
          </template>
        </el-table-column>

        <!-- 权益分类 -->
        <el-table-column
          prop="equityClassName"
          label="权益分类"
          width="120"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.equityClassName"
              size="small"
              :type="getEquityTagType(row.equityClassName)"
              class="equity-tag"
            >
              {{ row.equityClassName }}
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <!-- 设为精品 -->
        <!-- <el-table-column label="设为精品" width="110" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.isFeatured"
              :active-value="1"
              :inactive-value="2"
              @change="handleFeaturedChange(row)"
            ></el-switch>
          </template>
        </el-table-column> -->

        <!-- 推荐首页 -->
        <el-table-column label="推荐首页" width="110" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.isHome"
              :active-value="1"
              :inactive-value="2"
              @change="handleHomeChange(row)"
            ></el-switch>
          </template>
        </el-table-column>

        <!-- 上架状态 -->
        <el-table-column label="上架状态" width="110" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.state"
              :active-value="1"
              :inactive-value="2"
              @change="handleStateChange(row)"
            ></el-switch>
          </template>
        </el-table-column>

        <!-- 排序 -->
        <el-table-column
          prop="sort"
          label="排序"
          width="90"
          align="center"
        ></el-table-column>
        <!-- 发布时间 -->
        <el-table-column
          prop="createTime"
          label="发布时间"
          width="160"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.createTime }}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              class="action-btn btn-edit"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              class="action-btn btn-import"
              @click="handleImportQuestion(row)"
            >
              导入题目
            </el-button>
            <el-button
              type="text"
              size="small"
              class="action-btn btn-delete"
              @click="handleDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页器 -->
    <div class="pagination-wrapper flex justify-end marginTop20">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>

    <!-- 题目导入弹窗组件 -->
    <Import
      v-if="importShow"
      :show="importShow"
      :action="importAction"
      :downloadLink="importDownloadLink"
      :problemLink="importProblem"
      @close="importClose"
    />
  </div>
</template>

<script>
import {
  courseInfoList,
  courseInfoDelete,
  courseInfoStateUpdate,
  courseInfoHomeUpdate,
  courseInfoStateBatchUpdate,
  courseInfoFeaturedUpdate,
} from "@/api/course/info";
import { courseClassifyListAll } from "@/api/course/classify";
import Import from "@/components/import";

export default {
  name: "CourseInfo",
  components: {
    Import,
  },
  data() {
    return {
      searchData: {
        title: "",
        firstLevelClassifyId: "",
        secondLevelClassifyId: "",
        thirdLevelClassifyId: "",
        isFeatured: "",
        state: "",
      },
      searchClassifyIds: [], // 检索分类绑定
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], // 分页列表
      classifyTreeData: [], // 全部分类树
      allClassifyMap: {}, // 分类打平映射表
      multipleSelection: [], // 多选勾选
      showLoading: false,
      importShow: false, // 题目导入弹窗显隐控制
      importAction: "", // 题目导入上传接口URL
      importProblem: "/web/question/manage/template/error/export", // 错误数据导出地址
      importDownloadLink: "/web/question/manage/template/export", // 题目模板下载地址
      currentCourseId: "", // 当前选中的课程ID
    };
  },
  computed: {
    // 将分类树格式化为 Cascader 级联选择器支持的结构
    classifyCascaderOptions() {
      const format = (list) => {
        return list.map((item) => {
          const hasChildren =
            Array.isArray(item.children) && item.children.length > 0;
          return {
            value: item.id,
            label: item.name,
            children: hasChildren ? format(item.children) : null,
          };
        });
      };
      return format(this.classifyTreeData);
    },
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      await this.getClassifyTree();
      this.onLoad();
    },

    // 获取全量分类树
    async getClassifyTree() {
      try {
        const res = await courseClassifyListAll();
        if (res.code === 200 && Array.isArray(res.data)) {
          this.classifyTreeData = res.data;
          this.flattenClassify(res.data);
        }
      } catch (error) {
        console.error("加载分类数据失败:", error);
      }
    },

    // 打平分类树
    flattenClassify(tree) {
      const map = {};
      const traverse = (node) => {
        map[node.id] = node.name;
        if (Array.isArray(node.children) && node.children.length > 0) {
          node.children.forEach(traverse);
        }
      };
      tree.forEach(traverse);
      this.allClassifyMap = map;
    },

    // 权益小标签样式
    getEquityTagType(name) {
      if (!name) return "info";
      if (name.toUpperCase().includes("L1")) return "success";
      if (name.toUpperCase().includes("L2")) return "warning";
      if (name.toUpperCase().includes("L3")) return "danger";
      return "info";
    },

    /**
     * 分页加载课程列表
     * 该方法会根据当前的检索条件（标题、分类ID、精品状态、上架状态）及分页配置，
     * 向后端请求课程列表数据并更新本地表格。
     *
     * @param {void} 无直接输入参数，主要依赖组件的 searchClassifyIds, searchData 和 page 状态
     * @returns {void} 无返回值
     */
    onLoad() {
      this.showLoading = true;
      let firstId = "";
      let secondId = "";
      let thirdId = "";
      if (
        Array.isArray(this.searchClassifyIds) &&
        this.searchClassifyIds.length > 0
      ) {
        if (this.searchClassifyIds.length > 2) {
          firstId = this.searchClassifyIds[0];
          secondId = this.searchClassifyIds[1];
          thirdId = this.searchClassifyIds[2];
        } else if (this.searchClassifyIds.length === 2) {
          firstId = this.searchClassifyIds[0];
          secondId = this.searchClassifyIds[1];
        } else {
          // 仅有一个 ID 时，智能解析它是属于一级、二级还是三级
          const targetId = this.searchClassifyIds[0];
          const rootNode = this.classifyTreeData.find(
            (item) => item.id === targetId
          );
          if (rootNode) {
            firstId = targetId;
          } else {
            let foundParentId = "";
            let foundGrandparentId = "";
            let foundParentIdForThird = "";

            for (const root of this.classifyTreeData) {
              if (Array.isArray(root.children)) {
                // 检查是否是二级节点
                const subNode = root.children.find(
                  (child) => child.id === targetId
                );
                if (subNode) {
                  foundParentId = root.id;
                  break;
                }

                // 检查是否是三级节点
                for (const child of root.children) {
                  if (Array.isArray(child.children)) {
                    const grandChildNode = child.children.find(
                      (grandChild) => grandChild.id === targetId
                    );
                    if (grandChildNode) {
                      foundGrandparentId = root.id;
                      foundParentIdForThird = child.id;
                      break;
                    }
                  }
                }
                if (foundGrandparentId) {
                  break;
                }
              }
            }
            if (foundParentId) {
              firstId = foundParentId;
              secondId = targetId;
            } else if (foundGrandparentId) {
              firstId = foundGrandparentId;
              secondId = foundParentIdForThird;
              thirdId = targetId;
            } else {
              firstId = targetId;
            }
          }
        }
      }

      courseInfoList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        title: this.searchData.title.trim(),
        firstLevelClassifyId: firstId,
        secondLevelClassifyId: secondId,
        thirdLevelClassifyId: thirdId,
        isFeatured: this.searchData.isFeatured,
        state: this.searchData.state,
      })
        .then((res) => {
          this.showLoading = false;
          if (res.code === 200 && res.data) {
            this.tableData = res.data.records || [];
            this.page.total = res.data.total || 0;
          }
        })
        .catch(() => {
          this.showLoading = false;
        });
    },

    /**
     * 触发课程列表检索
     * 将页码重置为 1 后，调用 onLoad 加载数据。
     *
     * @param {void} 无参数
     * @returns {void} 无返回值
     */
    handleSearch() {
      this.page.currentPage = 1;
      this.onLoad();
    },

    /**
     * 重置检索条件
     * 将检索框及级联选择器数据清空，并将当前页码重置为 1，重新加载列表数据。
     *
     * @param {void} 无参数
     * @returns {void} 无返回值
     */
    handleReset() {
      this.searchData = {
        title: "",
        firstLevelClassifyId: "",
        secondLevelClassifyId: "",
        thirdLevelClassifyId: "",
        isFeatured: "",
        state: "",
      };
      this.searchClassifyIds = [];
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 列表多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 分页大小变动
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.currentPage = 1;
      this.onLoad();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.onLoad();
    },

    // 快捷切换精品状态
    handleFeaturedChange(row) {
      const original = row.isFeatured === 1 ? 2 : 1;
      const text = row.isFeatured === 1 ? "精品" : "普通";

      courseInfoFeaturedUpdate({
        id: row.id,
        isFeatured: row.isFeatured,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`已成功修改精品状态为：${text}`);
          } else {
            row.isFeatured = original;
          }
        })
        .catch(() => {
          row.isFeatured = original;
        });
    },

    // 快捷切换推荐首页
    handleHomeChange(row) {
      const original = row.isHome === 1 ? 2 : 1;
      const text = row.isHome === 1 ? "已推荐首页" : "已取消推荐首页";

      courseInfoHomeUpdate({
        id: row.id,
        isHome: row.isHome,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(text);
          } else {
            row.isHome = original;
          }
        })
        .catch(() => {
          row.isHome = original;
        });
    },

    // 快捷上架/下架状态
    handleStateChange(row) {
      const original = row.state === 1 ? 2 : 1;
      const text = row.state === 1 ? "上架" : "下架";

      courseInfoStateUpdate({
        id: row.id,
        state: row.state,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`课程【${row.title}】已成功${text}`);
          } else {
            row.state = original;
          }
        })
        .catch(() => {
          row.state = original;
        });
    },

    // 批量下架
    handleBatchOffline() {
      const ids = this.multipleSelection.map((item) => item.id);
      this.$confirm(`是否确认将选中的 ${ids.length} 个课程批量下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          courseInfoStateBatchUpdate({
            ids: ids,
            state: 2,
          }).then((res) => {
            if (res.code === 200) {
              this.$message.success("批量下架成功!");
              this.onLoad();
            }
          });
        })
        .catch(() => {});
    },

    // 删除单项课程
    handleDelete(row) {
      this.$confirm(`此操作将永久删除课程【${row.title}】, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          courseInfoDelete(row.id).then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功!");
              this.onLoad();
            }
          });
        })
        .catch(() => {});
    },

    // 新增按钮点击：跳转至 Form 页面
    handleCreate() {
      this.$router.push("/course/info/form");
    },

    // 编辑按钮点击：携带 id 参数跳转至 Form 页面
    handleEdit(row) {
      this.$router.push({
        path: "/course/info/form",
        query: { id: row.id },
      });
    },

    /**
     * 打开导入题目弹窗（针对单个课程）
     * 将选中的课程ID拼接至导入 API 接口路径，并唤起 Import 导入通用弹窗。
     *
     * @param {Object} row 课程列表项对象，需包含 id 属性
     * @returns {void} 无返回值
     */
    handleImportQuestion(row) {
      if (!row || !row.id) {
        this.$message.warning("课程数据异常，无法获取课程ID");
        return;
      }
      this.currentCourseId = row.id;
      this.importAction = `/api/web/question/manage/template/import/${row.id}`;
      this.importShow = true;
    },

    /**
     * 顶部检索栏【导入题目】按钮点击事件
     * 判断当前多选勾选的课程数量：
     * 1. 恰好勾选1条课程记录时，直接进行该课程的题目导入；
     * 2. 未勾选或勾选多条时提示用户。
     *
     * @param {void} 无参数
     * @returns {void} 无返回值
     */
    handleHeaderImport() {
      if (this.multipleSelection.length === 1) {
        this.handleImportQuestion(this.multipleSelection[0]);
      } else if (this.multipleSelection.length === 0) {
        this.$message.warning(
          "请在列表中勾选要导入题目的课程，或直接点击课程右侧操作列的【导入题目】按钮"
        );
      } else {
        this.$message.warning("一次只能选择一个课程导入题目");
      }
    },

    /**
     * 导入题目弹窗关闭后的回调函数
     * 关闭弹窗，若导入成功或部分成功（state为1或2），重新刷新课程列表。
     *
     * @param {number|undefined} state 导入状态码（1-全部成功，2-部分成功，3-全部失败，4-空数据失败）
     * @returns {void} 无返回值
     */
    importClose(state) {
      this.importShow = false;
      if (state === 1 || state === 2) {
        this.onLoad();
      }
    },
  },
};
</script>

<style scoped>
.main-content {
  padding: 20px;
  background-color: #ffffff;
  min-height: calc(100vh - 100px);
}

.search-wrapper {
  padding: 10px 0;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-container {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
}

.course-title {
  font-weight: 500;
  color: #333333;
}

.equity-tag {
  font-weight: 600;
  border-radius: 4px;
  padding: 0 12px;
}

.image-slot {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #c0c4cc;
  font-size: 16px;
}

/* 操作链接 */
.action-btn {
  font-weight: 500;
  font-size: 14px;
  margin: 0 8px;
  padding: 0;
  border: none;
}
.btn-edit {
  color: #409eff !important;
}
.btn-edit:hover {
  text-decoration: underline;
}
.btn-import {
  color: #f59a23 !important;
}
.btn-import:hover {
  text-decoration: underline;
}
.btn-delete {
  color: #ff001f !important;
}
.btn-delete:hover {
  color: #cc0018 !important;
  text-decoration: underline;
}

/* 间距工具类 */
.marginBottom20 {
  margin-bottom: 20px;
}
.marginTop20 {
  margin-top: 20px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.justify-end {
  justify-content: flex-end;
}
.align-items {
  align-items: center;
}
</style>
